export default {"src":"/_next/static/media/check-icon.0bb59de4.svg","height":27,"width":27,"blurWidth":0,"blurHeight":0};